import { SortDirection } from "@/types";

const useSort = () => {
  const sortStr = (
    a: string,
    b: string,
    dir: SortDirection = "ascend"
  ): number => {
    const fieldA = a?.toUpperCase() || "";
    const fieldB = b?.toUpperCase() || "";

    if (fieldA > fieldB) return dir === "ascend" ? 1 : -1;
    if (fieldA < fieldB) return dir === "ascend" ? -1 : 1;
    return 0;
  };

  const sortNumber = (a: number, b: number, dir: SortDirection): number => {
    return dir === "ascend" ? a - b : b - a;
  };

  const toOrder = (dir: SortDirection) => {
    return dir === "ascend" ? "asc" : "desc";
  };

  return { sortStr, sortNumber, toOrder };
};

export default useSort;
